import { cn } from "@/zapi-frontend/shared/lib/utils";
import { useProjectSidebarStore } from "@/zapi-frontend/stores/projectSidebarStore";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";
import { ValidationPanel } from "@/zapi-frontend/widgets/ValidationPanel";
import { IntelligenceQuestions } from "@/zapi-frontend/widgets/IntelligenceQuestions";
import { Claims } from "@/zapi-frontend/widgets/Claims";
import { CommentsIsland } from "@/zapi-frontend/widgets/CommentsIsland";
import { RepositoryIsland } from "./Repository/RepositoryIsland";

type TAnalysisIslandProps = { projectId: string; isChapterContentReady: boolean };

export function AnalysisIsland(props: TAnalysisIslandProps) {
  const { projectId, isChapterContentReady } = props;

  const { activeChapter } = useChapterStore();
  const { openSidebar } = useProjectSidebarStore();

  return (
    <div
      className={cn(
        "flex flex-col w-full h-full bg-white flex-1 overflow-hidden py-2 pr-2 pl-2 tablet:pl-0 rounded-[8px] relative z-10",
        !openSidebar && "opacity-0 pointer-events-none"
      )}
    >
      {openSidebar === "analysis" && (
        <div
          className={cn(
            "w-full h-full max-h-[calc(100vh-135px)] flex",
            activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
          )}
        >
          <ValidationPanel projectId={projectId} isChapterContentReady={isChapterContentReady} />
        </div>
      )}

      {openSidebar === "intelligence-questions" && (
        <div
          className={cn(
            "w-full h-full max-h-[calc(100vh-135px)] flex",
            activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
          )}
        >
          <IntelligenceQuestions projectId={projectId} />
        </div>
      )}

      {openSidebar === "claims" && (
        <div
          className={cn(
            "w-full h-full max-h-[calc(100vh-135px)] flex",
            activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
          )}
        >
          <Claims projectId={projectId} />
        </div>
      )}

      {openSidebar === "comments" && (
        <div
          className={cn(
            "w-full h-full max-h-[calc(100vh-135px)] flex",
            activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
          )}
        >
          <CommentsIsland />
        </div>
      )}

      {openSidebar === "vault" && (
        <div
          className={cn(
            "w-full h-full max-h-[calc(100vh-135px)] flex",
            activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
          )}
        >
          <RepositoryIsland open />
        </div>
      )}
    </div>
  );
}
